export const MONITOR_TYPE_BQ_THRESHOLD = 'bq_threshold';

export function formatMonitorCustomerOptionLabel(companyName, customerId) {
  if (!customerId) return '';
  if (!companyName) return customerId;
  return `${companyName} (${customerId})`;
}

export function buildCustomerNameById(customers) {
  const map = {};
  (customers || []).forEach((c) => {
    if (c?.id) {
      map[c.id] = c.companyName || c.id;
    }
  });
  return map;
}

export function monitorTypeNameById(monitorTypes, monitorTypeId) {
  const id = String(monitorTypeId ?? '');
  const match = (monitorTypes || []).find((t) => String(t.id) === id);
  return match?.name || '';
}

export function isBqThresholdMonitorType(monitorTypes, monitorTypeId) {
  return monitorTypeNameById(monitorTypes, monitorTypeId) === MONITOR_TYPE_BQ_THRESHOLD;
}

export function resolveJobCustomerId(job) {
  if (job?.customerId) return job.customerId;
  const ad = job?.additionalData;
  if (ad && typeof ad.customerId === 'string' && ad.customerId.trim()) {
    return ad.customerId;
  }
  return '';
}

export function displayCustomerForJob(job, customerNameById) {
  const customerId = resolveJobCustomerId(job);
  if (!customerId) {
    return { label: 'All', tooltip: null };
  }
  const name =
    customerNameById[customerId] ||
    (typeof job?.additionalData?.customerName === 'string'
      ? job.additionalData.customerName
      : null);
  const label = formatMonitorCustomerOptionLabel(name, customerId);
  return { label, tooltip: customerId };
}

export function mergeCustomerIntoAdditionalData(
  additionalData,
  { customerId, customerName, omitCustomerIdFromJson }
) {
  const next = additionalData ? { ...additionalData } : {};
  if (customerId) {
    next.customerName = customerName || customerId;
  } else {
    delete next.customerName;
  }
  if (omitCustomerIdFromJson) {
    delete next.customerId;
  }
  return Object.keys(next).length ? next : null;
}

export function buildAdditionalDataForSave(
  additionalDataText,
  { customerId, customerName }
) {
  let parsed = null;
  if (additionalDataText?.trim()) {
    parsed = JSON.parse(additionalDataText);
  }
  return mergeCustomerIntoAdditionalData(parsed, {
    customerId,
    customerName,
    omitCustomerIdFromJson: true,
  });
}

export function isMonitorJobFormValid(form) {
  return (
    form.monitorTypeId.trim() !== '' &&
    form.eventType.trim() !== '' &&
    form.cronHourInUtc.trim() !== '' &&
    form.cronDaysOfWeek.trim() !== ''
  );
}

export function filterMonitorJobs(jobs, query, customerNameById) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return jobs || [];
  return (jobs || []).filter((job) => {
    const idStr = String(job.id ?? '');
    if (idStr.includes(q)) return true;
    const eventType = (job.eventType || '').toLowerCase();
    if (eventType.includes(q)) return true;
    const customerId = resolveJobCustomerId(job);
    if (customerId.toLowerCase().includes(q)) return true;
    const name =
      customerNameById[customerId] ||
      (typeof job?.additionalData?.customerName === 'string'
        ? job.additionalData.customerName
        : '');
    if (name.toLowerCase().includes(q)) return true;
    return false;
  });
}

export function sortMonitorJobs(jobs) {
  return [...(jobs || [])].sort((a, b) => {
    const aEnabled = a.isEnabled ? 1 : 0;
    const bEnabled = b.isEnabled ? 1 : 0;
    if (aEnabled !== bEnabled) return bEnabled - aEnabled;
    const aId = Number(a.id) || 0;
    const bId = Number(b.id) || 0;
    return bId - aId;
  });
}

export function prepareMonitorJobsForTable(jobs, query, customerNameById) {
  return sortMonitorJobs(filterMonitorJobs(jobs, query, customerNameById));
}
